// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* this CSS contains only the basic CSS needed to run the app and use it */

.lgraphcanvas {
    /*cursor: crosshair;*/
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
	outline: none;
    font-family: Tahoma, sans-serif;
}

.lgraphcanvas * {
    box-sizing: border-box;
}

.litegraph.litecontextmenu {
    font-family: Tahoma, sans-serif;
    position: fixed;
    top: 100px;
    left: 100px;
    min-width: 100px;
    color: #aaf;
    padding: 0;
    box-shadow: 0 0 10px black !important;
    background-color: #2e2e2e !important;
	z-index: 10;
}

.litegraph.litecontextmenu.dark {
    background-color: #000 !important;
}

.litegraph.litecontextmenu .litemenu-title img {
    margin-top: 2px;
    margin-left: 2px;
    margin-right: 4px;
}

.litegraph.litecontextmenu .litemenu-entry {
    margin: 2px;
    padding: 2px;
}

.litegraph.litecontextmenu .litemenu-entry.submenu {
    background-color: #2e2e2e !important;
}

.litegraph.litecontextmenu.dark .litemenu-entry.submenu {
    background-color: #000 !important;
}

.litegraph .litemenubar ul {
    font-family: Tahoma, sans-serif;
    margin: 0;
    padding: 0;
}

.litegraph .litemenubar li {
    font-size: 14px;
    color: #999;
    display: inline-block;
    min-width: 50px;
    padding-left: 10px;
    padding-right: 10px;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    cursor: pointer;
}

.litegraph .litemenubar li:hover {
    background-color: #777;
    color: #eee;
}

.litegraph .litegraph .litemenubar-panel {
    position: absolute;
    top: 5px;
    left: 5px;
    min-width: 100px;
    background-color: #444;
    box-shadow: 0 0 3px black;
    padding: 4px;
    border-bottom: 2px solid #aaf;
    z-index: 10;
}

.litegraph .litemenu-entry,
.litemenu-title {
    font-size: 12px;
    color: #aaa;
    padding: 0 0 0 4px;
    margin: 2px;
    padding-left: 2px;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
}

.litegraph .litemenu-entry .icon {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin: 2px;
    vertical-align: top;
}

.litegraph .litemenu-entry.checked .icon {
    background-color: #aaf;
}

.litegraph .litemenu-entry .more {
    float: right;
    padding-right: 5px;
}

.litegraph .litemenu-entry.disabled {
    opacity: 0.5;
    cursor: default;
}

.litegraph .litemenu-entry.separator {
    display: block;
    border-top: 1px solid #333;
    border-bottom: 1px solid #666;
    width: 100%;
    height: 0px;
    margin: 3px 0 2px 0;
    background-color: transparent;
    padding: 0 !important;
    cursor: default !important;
}

.litegraph .litemenu-entry.has_submenu {
    border-right: 2px solid cyan;
}

.litegraph .litemenu-title {
    color: #dde;
    background-color: #111;
    margin: 0;
    padding: 2px;
    cursor: default;
}

.litegraph .litemenu-entry:hover:not(.disabled):not(.separator) {
    background-color: #444 !important;
    color: #eee;
    transition: all 0.2s;
}

.litegraph .litemenu-entry .property_name {
    display: inline-block;
    text-align: left;
    min-width: 80px;
    min-height: 1.2em;
}

.litegraph .litemenu-entry .property_value {
    display: inline-block;
    background-color: rgba(0, 0, 0, 0.5);
    text-align: right;
    min-width: 80px;
    min-height: 1.2em;
    vertical-align: middle;
    padding-right: 10px;
}

.litegraph.litesearchbox {
    font-family: Tahoma, sans-serif;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    padding-top: 4px;
}

.litegraph.litesearchbox input,
.litegraph.litesearchbox select {
    margin-top: 3px;
    min-width: 60px;
    min-height: 1.5em;
    background-color: black;
    border: 0;
    color: white;
    padding-left: 10px;
    margin-right: 5px;
}

.litegraph.litesearchbox .name {
    display: inline-block;
    min-width: 60px;
    min-height: 1.5em;
    padding-left: 10px;
}

.litegraph.litesearchbox .helper {
    overflow: auto;
    max-height: 200px;
    margin-top: 2px;
}

.litegraph.lite-search-item {
    font-family: Tahoma, sans-serif;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    padding-top: 2px;
}

.litegraph.lite-search-item.not_in_filter{
    /*background-color: rgba(50, 50, 50, 0.5);*/
    /*color: #999;*/
    color: #B99;
    font-style: italic;
}

.litegraph.lite-search-item.generic_type{
    /*background-color: rgba(50, 50, 50, 0.5);*/
    /*color: #DD9;*/
    color: #999;
    font-style: italic;
}

.litegraph.lite-search-item:hover,
.litegraph.lite-search-item.selected {
    cursor: pointer;
    background-color: white;
    color: black;
}

/* DIALOGs ******/

.litegraph .dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -150px;
    margin-left: -200px;

    background-color: #2A2A2A;

    min-width: 400px;
    min-height: 200px;
	box-shadow: 0 0 4px #111;
    border-radius: 6px;
}

.litegraph .dialog.settings {
	left: 10px;
	top: 10px;
	height: calc( 100% - 20px );
	margin: auto;
    max-width: 50%;
}

.litegraph .dialog.centered {
    top: 50px;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    min-width: 600px;
    min-height: 300px;
    height: calc( 100% - 100px );
	margin: auto;
}

.litegraph .dialog .close {
    float: right;
	margin: 4px;
	margin-right: 10px;
	cursor: pointer;
	font-size: 1.4em;
}

.litegraph .dialog .close:hover {
	color: white;
}

.litegraph .dialog .dialog-header {
	color: #AAA;
	border-bottom: 1px solid #161616;
}

.litegraph .dialog .dialog-header { height: 40px; }
.litegraph .dialog .dialog-footer { height: 50px; padding: 10px; border-top: 1px solid #1a1a1a;}

.litegraph .dialog .dialog-header .dialog-title {
    font: 20px "Arial";
    margin: 4px;
    padding: 4px 10px;
    display: inline-block;
}

.litegraph .dialog .dialog-content, .litegraph .dialog .dialog-alt-content {
    height: calc(100% - 90px);
    width: 100%;
	min-height: 100px;
    display: inline-block;
	color: #AAA;
    /*background-color: black;*/
    overflow: auto;
}

.litegraph .dialog .dialog-content h3 {
	margin: 10px;
}

.litegraph .dialog .dialog-content .connections {
	flex-direction: row;
}

.litegraph .dialog .dialog-content .connections .connections_side {
	width: calc(50% - 5px);
	min-height: 100px;
	background-color: black;
	display: flex;
}

.litegraph .dialog .node_type {
	font-size: 1.2em;
	display: block;
	margin: 10px;
}

.litegraph .dialog .node_desc {
	opacity: 0.5;
	display: block;
	margin: 10px;
}

.litegraph .dialog .separator {
	display: block;
	width: calc( 100% - 4px );
	height: 1px;
	border-top: 1px solid #000;
	border-bottom: 1px solid #333;
	margin: 10px 2px;
	padding: 0;
}

.litegraph .dialog .property {
	margin-bottom: 2px;
	padding: 4px;
}

.litegraph .dialog .property:hover {
	background: #545454;
}

.litegraph .dialog .property_name {
	color: #737373;
    display: inline-block;
    text-align: left;
    vertical-align: top;
    width: 160px;
	padding-left: 4px;
	overflow: hidden;
    margin-right: 6px;
}

.litegraph .dialog .property:hover .property_name {
    color: white;
}

.litegraph .dialog .property_value {
    display: inline-block;
    text-align: right;
	color: #AAA;
	background-color: #1A1A1A;
    /*width: calc( 100% - 122px );*/
    max-width: calc( 100% - 162px );
    min-width: 200px;
	max-height: 300px;
    min-height: 20px;
    padding: 4px;
	padding-right: 12px;
	overflow: hidden;
	cursor: pointer;
	border-radius: 3px;
}

.litegraph .dialog .property_value:hover {
	color: white;
}

.litegraph .dialog .property.boolean .property_value {
	padding-right: 30px;
    color: #A88;
    /*width: auto;
    float: right;*/
}

.litegraph .dialog .property.boolean.bool-on .property_name{
    color: #8A8;
}
.litegraph .dialog .property.boolean.bool-on .property_value{
    color: #8A8;
}

.litegraph .dialog .btn {
	border: 0;
	border-radius: 4px;
    padding: 4px 20px;
    margin-left: 0px;
    background-color: #060606;
    color: #8e8e8e;
}

.litegraph .dialog .btn:hover {
    background-color: #111;
    color: #FFF;
}

.litegraph .dialog .btn.delete:hover {
    background-color: #F33;
    color: black;
}

.litegraph .subgraph_property {
	padding: 4px;
}

.litegraph .subgraph_property:hover {
	background-color: #333;
}

.litegraph .subgraph_property.extra {
    margin-top: 8px;
}

.litegraph .subgraph_property span.name {
	font-size: 1.3em;
	padding-left: 4px;
}

.litegraph .subgraph_property span.type {
	opacity: 0.5;
	margin-right: 20px;
	padding-left: 4px;
}

.litegraph .subgraph_property span.label {
	display: inline-block;
	width: 60px;
	padding:  0px 10px;
}

.litegraph .subgraph_property input {
	width: 140px;
	color: #999;
	background-color: #1A1A1A;
	border-radius: 4px;
	border: 0;
	margin-right: 10px;
	padding: 4px;
	padding-left: 10px;
}

.litegraph .subgraph_property button {
	background-color: #1c1c1c;
	color: #aaa;
	border: 0;
	border-radius: 2px;
	padding: 4px 10px;
	cursor: pointer;
}

.litegraph .subgraph_property.extra {
	color: #ccc;
}

.litegraph .subgraph_property.extra input {
	background-color: #111;
}

.litegraph .bullet_icon {
	margin-left: 10px;
	border-radius: 10px;
	width: 12px;
	height: 12px;
	background-color: #666;
	display: inline-block;
	margin-top: 2px;
	margin-right: 4px;
    transition: background-color 0.1s ease 0s;
    -moz-transition: background-color 0.1s ease 0s;
}

.litegraph .bullet_icon:hover {
	background-color: #698;
	cursor: pointer;
} 

/* OLD */

.graphcontextmenu {
    padding: 4px;
    min-width: 100px;
}

.graphcontextmenu-title {
    color: #dde;
    background-color: #222;
    margin: 0;
    padding: 2px;
    cursor: default;
}

.graphmenu-entry {
    box-sizing: border-box;
    margin: 2px;
    padding-left: 20px;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    transition: all linear 0.3s;
}

.graphmenu-entry.event,
.litemenu-entry.event {
    border-left: 8px solid orange;
    padding-left: 12px;
}

.graphmenu-entry.disabled {
    opacity: 0.3;
}

.graphmenu-entry.submenu {
    border-right: 2px solid #eee;
}

.graphmenu-entry:hover {
    background-color: #555;
}

.graphmenu-entry.separator {
    background-color: #111;
    border-bottom: 1px solid #666;
    height: 1px;
    width: calc(100% - 20px);
    -moz-width: calc(100% - 20px);
    -webkit-width: calc(100% - 20px);
}

.graphmenu-entry .property_name {
    display: inline-block;
    text-align: left;
    min-width: 80px;
    min-height: 1.2em;
}

.graphmenu-entry .property_value,
.litemenu-entry .property_value {
    display: inline-block;
    background-color: rgba(0, 0, 0, 0.5);
    text-align: right;
    min-width: 80px;
    min-height: 1.2em;
    vertical-align: middle;
    padding-right: 10px;
}

.graphdialog {
    position: absolute;
    top: 10px;
    left: 10px;
    min-height: 2em;
    background-color: #333;
    font-size: 1.2em;
    box-shadow: 0 0 10px black !important;
	z-index: 10;
}

.graphdialog.rounded {
    border-radius: 12px;
    padding-right: 2px;
}

.graphdialog .name {
    display: inline-block;
    min-width: 60px;
    min-height: 1.5em;
    padding-left: 10px;
}

.graphdialog input,
.graphdialog textarea,
.graphdialog select {
    margin: 3px;
    min-width: 60px;
    min-height: 1.5em;
    background-color: black;
    border: 0;
    color: white;
    padding-left: 10px;
    outline: none;
}

.graphdialog textarea {
	min-height: 150px;
}

.graphdialog button {
    margin-top: 3px;
    vertical-align: top;
    background-color: #999;
	border: 0;
}

.graphdialog button.rounded,
.graphdialog input.rounded {
    border-radius: 0 12px 12px 0;
}

.graphdialog .helper {
    overflow: auto;
    max-height: 200px;
}

.graphdialog .help-item {
    padding-left: 10px;
}

.graphdialog .help-item:hover,
.graphdialog .help-item.selected {
    cursor: pointer;
    background-color: white;
    color: black;
}

.litegraph .dialog {
    min-height: 0;
}
.litegraph .dialog .dialog-content {
display: block;
}
.litegraph .dialog .dialog-content .subgraph_property {
padding: 5px;
}
.litegraph .dialog .dialog-footer {
margin: 0;
}
.litegraph .dialog .dialog-footer .subgraph_property {
margin-top: 0;
display: flex;
align-items: center;
padding: 5px;
}
.litegraph .dialog .dialog-footer .subgraph_property .name {
flex: 1;
}
.litegraph .graphdialog {
display: flex;
align-items: center;
border-radius: 20px;
padding: 4px 10px;
position: fixed;
}
.litegraph .graphdialog .name {
padding: 0;
min-height: 0;
font-size: 16px;
vertical-align: middle;
}
.litegraph .graphdialog .value {
font-size: 16px;
min-height: 0;
margin: 0 10px;
padding: 2px 5px;
}
.litegraph .graphdialog input[type="checkbox"] {
width: 16px;
height: 16px;
}
.litegraph .graphdialog button {
padding: 4px 18px;
border-radius: 20px;
cursor: pointer;
}
  
`, "",{"version":3,"sources":["webpack://./node_modules/litegraph.js/css/litegraph.css"],"names":[],"mappings":"AAAA,0EAA0E;;AAE1E;IACI,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;CAC5B,aAAa;IACV,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,qCAAqC;IACrC,oCAAoC;CACvC,WAAW;AACZ;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;IAC7B,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,6BAA6B;IAC7B,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;IACpC,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;IAC3C,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,uBAAuB;IACvB,YAAY;AAChB;;AAEA,iBAAiB;;AAEjB;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,mBAAmB;;IAEnB,yBAAyB;;IAEzB,gBAAgB;IAChB,iBAAiB;CACpB,wBAAwB;IACrB,kBAAkB;AACtB;;AAEA;CACC,UAAU;CACV,SAAS;CACT,2BAA2B;CAC3B,YAAY;IACT,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;CAC/B,YAAY;AACb;;AAEA;IACI,YAAY;CACf,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,gCAAgC;AACjC;;AAEA,oCAAoC,YAAY,EAAE;AAClD,oCAAoC,YAAY,EAAE,aAAa,EAAE,6BAA6B,CAAC;;AAE/F;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,WAAW;CACd,iBAAiB;IACd,qBAAqB;CACxB,WAAW;IACR,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,iBAAiB;CACjB,uBAAuB;CACvB,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,YAAY;AACb;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,WAAW;CACX,0BAA0B;CAC1B,6BAA6B;CAC7B,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;IACX,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;CACf,iBAAiB;CACjB,gBAAgB;IACb,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;CACpB,WAAW;CACX,yBAAyB;IACtB,+BAA+B;IAC/B,+BAA+B;IAC/B,gBAAgB;CACnB,iBAAiB;IACd,gBAAgB;IAChB,YAAY;CACf,mBAAmB;CACnB,gBAAgB;CAChB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,mBAAmB;IAChB,WAAW;IACX;kBACc;AAClB;;AAEA;IACI,WAAW;AACf;AACA;IACI,WAAW;AACf;;AAEA;CACC,SAAS;CACT,kBAAkB;IACf,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,sBAAsB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,kBAAkB;CAClB,SAAS;CACT,kBAAkB;CAClB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,SAAS;CACT,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;IACd,yCAAyC;IACzC,8CAA8C;AAClD;;AAEA;CACC,sBAAsB;CACtB,eAAe;AAChB;;AAEA,QAAQ;;AAER;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;;IAEI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,WAAW;IACX,wBAAwB;IACxB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,qBAAqB;IACrB,oCAAoC;IACpC,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,qCAAqC;CACxC,WAAW;AACZ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;IAGI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,sBAAsB;CACzB,SAAS;AACV;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;AACA;AACA,cAAc;AACd;AACA;AACA,YAAY;AACZ;AACA;AACA,SAAS;AACT;AACA;AACA,aAAa;AACb,aAAa;AACb,mBAAmB;AACnB,YAAY;AACZ;AACA;AACA,OAAO;AACP;AACA;AACA,aAAa;AACb,mBAAmB;AACnB,mBAAmB;AACnB,iBAAiB;AACjB,eAAe;AACf;AACA;AACA,UAAU;AACV,aAAa;AACb,eAAe;AACf,sBAAsB;AACtB;AACA;AACA,eAAe;AACf,aAAa;AACb,cAAc;AACd,gBAAgB;AAChB;AACA;AACA,WAAW;AACX,YAAY;AACZ;AACA;AACA,iBAAiB;AACjB,mBAAmB;AACnB,eAAe;AACf","sourcesContent":["/* this CSS contains only the basic CSS needed to run the app and use it */\n\n.lgraphcanvas {\n    /*cursor: crosshair;*/\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n\toutline: none;\n    font-family: Tahoma, sans-serif;\n}\n\n.lgraphcanvas * {\n    box-sizing: border-box;\n}\n\n.litegraph.litecontextmenu {\n    font-family: Tahoma, sans-serif;\n    position: fixed;\n    top: 100px;\n    left: 100px;\n    min-width: 100px;\n    color: #aaf;\n    padding: 0;\n    box-shadow: 0 0 10px black !important;\n    background-color: #2e2e2e !important;\n\tz-index: 10;\n}\n\n.litegraph.litecontextmenu.dark {\n    background-color: #000 !important;\n}\n\n.litegraph.litecontextmenu .litemenu-title img {\n    margin-top: 2px;\n    margin-left: 2px;\n    margin-right: 4px;\n}\n\n.litegraph.litecontextmenu .litemenu-entry {\n    margin: 2px;\n    padding: 2px;\n}\n\n.litegraph.litecontextmenu .litemenu-entry.submenu {\n    background-color: #2e2e2e !important;\n}\n\n.litegraph.litecontextmenu.dark .litemenu-entry.submenu {\n    background-color: #000 !important;\n}\n\n.litegraph .litemenubar ul {\n    font-family: Tahoma, sans-serif;\n    margin: 0;\n    padding: 0;\n}\n\n.litegraph .litemenubar li {\n    font-size: 14px;\n    color: #999;\n    display: inline-block;\n    min-width: 50px;\n    padding-left: 10px;\n    padding-right: 10px;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    cursor: pointer;\n}\n\n.litegraph .litemenubar li:hover {\n    background-color: #777;\n    color: #eee;\n}\n\n.litegraph .litegraph .litemenubar-panel {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    min-width: 100px;\n    background-color: #444;\n    box-shadow: 0 0 3px black;\n    padding: 4px;\n    border-bottom: 2px solid #aaf;\n    z-index: 10;\n}\n\n.litegraph .litemenu-entry,\n.litemenu-title {\n    font-size: 12px;\n    color: #aaa;\n    padding: 0 0 0 4px;\n    margin: 2px;\n    padding-left: 2px;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    user-select: none;\n    cursor: pointer;\n}\n\n.litegraph .litemenu-entry .icon {\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    margin: 2px;\n    vertical-align: top;\n}\n\n.litegraph .litemenu-entry.checked .icon {\n    background-color: #aaf;\n}\n\n.litegraph .litemenu-entry .more {\n    float: right;\n    padding-right: 5px;\n}\n\n.litegraph .litemenu-entry.disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n\n.litegraph .litemenu-entry.separator {\n    display: block;\n    border-top: 1px solid #333;\n    border-bottom: 1px solid #666;\n    width: 100%;\n    height: 0px;\n    margin: 3px 0 2px 0;\n    background-color: transparent;\n    padding: 0 !important;\n    cursor: default !important;\n}\n\n.litegraph .litemenu-entry.has_submenu {\n    border-right: 2px solid cyan;\n}\n\n.litegraph .litemenu-title {\n    color: #dde;\n    background-color: #111;\n    margin: 0;\n    padding: 2px;\n    cursor: default;\n}\n\n.litegraph .litemenu-entry:hover:not(.disabled):not(.separator) {\n    background-color: #444 !important;\n    color: #eee;\n    transition: all 0.2s;\n}\n\n.litegraph .litemenu-entry .property_name {\n    display: inline-block;\n    text-align: left;\n    min-width: 80px;\n    min-height: 1.2em;\n}\n\n.litegraph .litemenu-entry .property_value {\n    display: inline-block;\n    background-color: rgba(0, 0, 0, 0.5);\n    text-align: right;\n    min-width: 80px;\n    min-height: 1.2em;\n    vertical-align: middle;\n    padding-right: 10px;\n}\n\n.litegraph.litesearchbox {\n    font-family: Tahoma, sans-serif;\n    position: absolute;\n    background-color: rgba(0, 0, 0, 0.5);\n    padding-top: 4px;\n}\n\n.litegraph.litesearchbox input,\n.litegraph.litesearchbox select {\n    margin-top: 3px;\n    min-width: 60px;\n    min-height: 1.5em;\n    background-color: black;\n    border: 0;\n    color: white;\n    padding-left: 10px;\n    margin-right: 5px;\n}\n\n.litegraph.litesearchbox .name {\n    display: inline-block;\n    min-width: 60px;\n    min-height: 1.5em;\n    padding-left: 10px;\n}\n\n.litegraph.litesearchbox .helper {\n    overflow: auto;\n    max-height: 200px;\n    margin-top: 2px;\n}\n\n.litegraph.lite-search-item {\n    font-family: Tahoma, sans-serif;\n    background-color: rgba(0, 0, 0, 0.5);\n    color: white;\n    padding-top: 2px;\n}\n\n.litegraph.lite-search-item.not_in_filter{\n    /*background-color: rgba(50, 50, 50, 0.5);*/\n    /*color: #999;*/\n    color: #B99;\n    font-style: italic;\n}\n\n.litegraph.lite-search-item.generic_type{\n    /*background-color: rgba(50, 50, 50, 0.5);*/\n    /*color: #DD9;*/\n    color: #999;\n    font-style: italic;\n}\n\n.litegraph.lite-search-item:hover,\n.litegraph.lite-search-item.selected {\n    cursor: pointer;\n    background-color: white;\n    color: black;\n}\n\n/* DIALOGs ******/\n\n.litegraph .dialog {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-top: -150px;\n    margin-left: -200px;\n\n    background-color: #2A2A2A;\n\n    min-width: 400px;\n    min-height: 200px;\n\tbox-shadow: 0 0 4px #111;\n    border-radius: 6px;\n}\n\n.litegraph .dialog.settings {\n\tleft: 10px;\n\ttop: 10px;\n\theight: calc( 100% - 20px );\n\tmargin: auto;\n    max-width: 50%;\n}\n\n.litegraph .dialog.centered {\n    top: 50px;\n    left: 50%;\n    position: absolute;\n    transform: translateX(-50%);\n    min-width: 600px;\n    min-height: 300px;\n    height: calc( 100% - 100px );\n\tmargin: auto;\n}\n\n.litegraph .dialog .close {\n    float: right;\n\tmargin: 4px;\n\tmargin-right: 10px;\n\tcursor: pointer;\n\tfont-size: 1.4em;\n}\n\n.litegraph .dialog .close:hover {\n\tcolor: white;\n}\n\n.litegraph .dialog .dialog-header {\n\tcolor: #AAA;\n\tborder-bottom: 1px solid #161616;\n}\n\n.litegraph .dialog .dialog-header { height: 40px; }\n.litegraph .dialog .dialog-footer { height: 50px; padding: 10px; border-top: 1px solid #1a1a1a;}\n\n.litegraph .dialog .dialog-header .dialog-title {\n    font: 20px \"Arial\";\n    margin: 4px;\n    padding: 4px 10px;\n    display: inline-block;\n}\n\n.litegraph .dialog .dialog-content, .litegraph .dialog .dialog-alt-content {\n    height: calc(100% - 90px);\n    width: 100%;\n\tmin-height: 100px;\n    display: inline-block;\n\tcolor: #AAA;\n    /*background-color: black;*/\n    overflow: auto;\n}\n\n.litegraph .dialog .dialog-content h3 {\n\tmargin: 10px;\n}\n\n.litegraph .dialog .dialog-content .connections {\n\tflex-direction: row;\n}\n\n.litegraph .dialog .dialog-content .connections .connections_side {\n\twidth: calc(50% - 5px);\n\tmin-height: 100px;\n\tbackground-color: black;\n\tdisplay: flex;\n}\n\n.litegraph .dialog .node_type {\n\tfont-size: 1.2em;\n\tdisplay: block;\n\tmargin: 10px;\n}\n\n.litegraph .dialog .node_desc {\n\topacity: 0.5;\n\tdisplay: block;\n\tmargin: 10px;\n}\n\n.litegraph .dialog .separator {\n\tdisplay: block;\n\twidth: calc( 100% - 4px );\n\theight: 1px;\n\tborder-top: 1px solid #000;\n\tborder-bottom: 1px solid #333;\n\tmargin: 10px 2px;\n\tpadding: 0;\n}\n\n.litegraph .dialog .property {\n\tmargin-bottom: 2px;\n\tpadding: 4px;\n}\n\n.litegraph .dialog .property:hover {\n\tbackground: #545454;\n}\n\n.litegraph .dialog .property_name {\n\tcolor: #737373;\n    display: inline-block;\n    text-align: left;\n    vertical-align: top;\n    width: 160px;\n\tpadding-left: 4px;\n\toverflow: hidden;\n    margin-right: 6px;\n}\n\n.litegraph .dialog .property:hover .property_name {\n    color: white;\n}\n\n.litegraph .dialog .property_value {\n    display: inline-block;\n    text-align: right;\n\tcolor: #AAA;\n\tbackground-color: #1A1A1A;\n    /*width: calc( 100% - 122px );*/\n    max-width: calc( 100% - 162px );\n    min-width: 200px;\n\tmax-height: 300px;\n    min-height: 20px;\n    padding: 4px;\n\tpadding-right: 12px;\n\toverflow: hidden;\n\tcursor: pointer;\n\tborder-radius: 3px;\n}\n\n.litegraph .dialog .property_value:hover {\n\tcolor: white;\n}\n\n.litegraph .dialog .property.boolean .property_value {\n\tpadding-right: 30px;\n    color: #A88;\n    /*width: auto;\n    float: right;*/\n}\n\n.litegraph .dialog .property.boolean.bool-on .property_name{\n    color: #8A8;\n}\n.litegraph .dialog .property.boolean.bool-on .property_value{\n    color: #8A8;\n}\n\n.litegraph .dialog .btn {\n\tborder: 0;\n\tborder-radius: 4px;\n    padding: 4px 20px;\n    margin-left: 0px;\n    background-color: #060606;\n    color: #8e8e8e;\n}\n\n.litegraph .dialog .btn:hover {\n    background-color: #111;\n    color: #FFF;\n}\n\n.litegraph .dialog .btn.delete:hover {\n    background-color: #F33;\n    color: black;\n}\n\n.litegraph .subgraph_property {\n\tpadding: 4px;\n}\n\n.litegraph .subgraph_property:hover {\n\tbackground-color: #333;\n}\n\n.litegraph .subgraph_property.extra {\n    margin-top: 8px;\n}\n\n.litegraph .subgraph_property span.name {\n\tfont-size: 1.3em;\n\tpadding-left: 4px;\n}\n\n.litegraph .subgraph_property span.type {\n\topacity: 0.5;\n\tmargin-right: 20px;\n\tpadding-left: 4px;\n}\n\n.litegraph .subgraph_property span.label {\n\tdisplay: inline-block;\n\twidth: 60px;\n\tpadding:  0px 10px;\n}\n\n.litegraph .subgraph_property input {\n\twidth: 140px;\n\tcolor: #999;\n\tbackground-color: #1A1A1A;\n\tborder-radius: 4px;\n\tborder: 0;\n\tmargin-right: 10px;\n\tpadding: 4px;\n\tpadding-left: 10px;\n}\n\n.litegraph .subgraph_property button {\n\tbackground-color: #1c1c1c;\n\tcolor: #aaa;\n\tborder: 0;\n\tborder-radius: 2px;\n\tpadding: 4px 10px;\n\tcursor: pointer;\n}\n\n.litegraph .subgraph_property.extra {\n\tcolor: #ccc;\n}\n\n.litegraph .subgraph_property.extra input {\n\tbackground-color: #111;\n}\n\n.litegraph .bullet_icon {\n\tmargin-left: 10px;\n\tborder-radius: 10px;\n\twidth: 12px;\n\theight: 12px;\n\tbackground-color: #666;\n\tdisplay: inline-block;\n\tmargin-top: 2px;\n\tmargin-right: 4px;\n    transition: background-color 0.1s ease 0s;\n    -moz-transition: background-color 0.1s ease 0s;\n}\n\n.litegraph .bullet_icon:hover {\n\tbackground-color: #698;\n\tcursor: pointer;\n} \n\n/* OLD */\n\n.graphcontextmenu {\n    padding: 4px;\n    min-width: 100px;\n}\n\n.graphcontextmenu-title {\n    color: #dde;\n    background-color: #222;\n    margin: 0;\n    padding: 2px;\n    cursor: default;\n}\n\n.graphmenu-entry {\n    box-sizing: border-box;\n    margin: 2px;\n    padding-left: 20px;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    transition: all linear 0.3s;\n}\n\n.graphmenu-entry.event,\n.litemenu-entry.event {\n    border-left: 8px solid orange;\n    padding-left: 12px;\n}\n\n.graphmenu-entry.disabled {\n    opacity: 0.3;\n}\n\n.graphmenu-entry.submenu {\n    border-right: 2px solid #eee;\n}\n\n.graphmenu-entry:hover {\n    background-color: #555;\n}\n\n.graphmenu-entry.separator {\n    background-color: #111;\n    border-bottom: 1px solid #666;\n    height: 1px;\n    width: calc(100% - 20px);\n    -moz-width: calc(100% - 20px);\n    -webkit-width: calc(100% - 20px);\n}\n\n.graphmenu-entry .property_name {\n    display: inline-block;\n    text-align: left;\n    min-width: 80px;\n    min-height: 1.2em;\n}\n\n.graphmenu-entry .property_value,\n.litemenu-entry .property_value {\n    display: inline-block;\n    background-color: rgba(0, 0, 0, 0.5);\n    text-align: right;\n    min-width: 80px;\n    min-height: 1.2em;\n    vertical-align: middle;\n    padding-right: 10px;\n}\n\n.graphdialog {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    min-height: 2em;\n    background-color: #333;\n    font-size: 1.2em;\n    box-shadow: 0 0 10px black !important;\n\tz-index: 10;\n}\n\n.graphdialog.rounded {\n    border-radius: 12px;\n    padding-right: 2px;\n}\n\n.graphdialog .name {\n    display: inline-block;\n    min-width: 60px;\n    min-height: 1.5em;\n    padding-left: 10px;\n}\n\n.graphdialog input,\n.graphdialog textarea,\n.graphdialog select {\n    margin: 3px;\n    min-width: 60px;\n    min-height: 1.5em;\n    background-color: black;\n    border: 0;\n    color: white;\n    padding-left: 10px;\n    outline: none;\n}\n\n.graphdialog textarea {\n\tmin-height: 150px;\n}\n\n.graphdialog button {\n    margin-top: 3px;\n    vertical-align: top;\n    background-color: #999;\n\tborder: 0;\n}\n\n.graphdialog button.rounded,\n.graphdialog input.rounded {\n    border-radius: 0 12px 12px 0;\n}\n\n.graphdialog .helper {\n    overflow: auto;\n    max-height: 200px;\n}\n\n.graphdialog .help-item {\n    padding-left: 10px;\n}\n\n.graphdialog .help-item:hover,\n.graphdialog .help-item.selected {\n    cursor: pointer;\n    background-color: white;\n    color: black;\n}\n\n.litegraph .dialog {\n    min-height: 0;\n}\n.litegraph .dialog .dialog-content {\ndisplay: block;\n}\n.litegraph .dialog .dialog-content .subgraph_property {\npadding: 5px;\n}\n.litegraph .dialog .dialog-footer {\nmargin: 0;\n}\n.litegraph .dialog .dialog-footer .subgraph_property {\nmargin-top: 0;\ndisplay: flex;\nalign-items: center;\npadding: 5px;\n}\n.litegraph .dialog .dialog-footer .subgraph_property .name {\nflex: 1;\n}\n.litegraph .graphdialog {\ndisplay: flex;\nalign-items: center;\nborder-radius: 20px;\npadding: 4px 10px;\nposition: fixed;\n}\n.litegraph .graphdialog .name {\npadding: 0;\nmin-height: 0;\nfont-size: 16px;\nvertical-align: middle;\n}\n.litegraph .graphdialog .value {\nfont-size: 16px;\nmin-height: 0;\nmargin: 0 10px;\npadding: 2px 5px;\n}\n.litegraph .graphdialog input[type=\"checkbox\"] {\nwidth: 16px;\nheight: 16px;\n}\n.litegraph .graphdialog button {\npadding: 4px 18px;\nborder-radius: 20px;\ncursor: pointer;\n}\n  \n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
